/** @jsxRuntime classic */
/** @jsx jsx */
// MODULES
import { jsx, css } from "@emotion/react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

// LOCAL
import useServicesData from "../Services/useServicesData";
import { Link } from "react-router-dom";
import ServiceCard from "../Services/ServiceCard";
import { partnerStyles } from "./partnerStyles";

const SampleNextArrow = ({ className, style, onClick }) => (
  <button
    type="button"
    className={`${className} arrow-button`}
    style={style}
    onClick={onClick}
    aria-label="Next slide"
  >
    <FaChevronRight aria-hidden="true" />
  </button>
);

const SamplePrevArrow = ({ className, style, onClick }) => (
  <button
    type="button"
    className={`${className} arrow-button`}
    style={style}
    onClick={onClick}
    aria-label="Previous slide"
  >
    <FaChevronLeft aria-hidden="true" />
  </button>
);

export default function Cards() {
  let settings = {
    infinite: true,
    lazyLoad: true,
    autoplay: false,
    dots: true,

    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    centerMode: true,
    variableWidth: false,
    adaptativeHight: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 3024,
        settings: {
          centerMode: false,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const services = useServicesData();
  // console.log(services)

  // const {
  //   dictionary: { dictionary },
  // } = this.context
  const changeStyles = true;
  return (
    <div className="partners" css={partnerStyles}>
      {/* <AiOutlineArrowRight style={{ color: "white" }} /> */}

      <Slider {...settings} className="partners">
        {services.map((item) => (
          <Link key={item.title} to="/services">
            <ServiceCard
              title={item.title}
              Icon={item.icon}
              text={item.text_light}
              size={item.size}
              changeStyles={changeStyles}
            />
          </Link>
        ))}
      </Slider>
    </div>
  );
}
